import { defaults as _defaults } from 'lodash';
class StateProvince {
    PK;
    Name;
    Data;
    constructor(stateProvince) {
        _defaults(this, stateProvince);
    }
}
export default StateProvince;
